export const evalsConstants = {
  GET_EVALUATIONS: "GET_EVALUATIONS",
  GET_EVALUATION: "GET_EVALUATION",
  GET_RELEVE: "GET_RELEVE_NOTES",
  GET_PV: "GET_PV",
  GET_PV_ANNUEL: "GET_PV_ANNUEL",
  GET_DETAILS: "GET_DETAILS",
  SET_LOADING: "SET_LOADING",

  GET_TYPES: "GET_TYPES",
  GET_TYPE: "GET_TYPE",

  GET_NOTES: "GET_NOTES",
};
